import { useState } from "react";
import { Fade, IconButton } from "@mui/material";

import { useNavigate } from "react-router";

import AppBarButtonWrapper from "@/components/AppBarButtonWrapper";
import useFetch from "@/hooks/useFetch";
import FilterIcon from "@mui/icons-material/FilterList";

import WorkCenterHeader from "@/pages/production/queue-list/work-centers/WorkCenterHeader";
import QueueListIndexComponent from "@/pages/production/queue-list/work-centers/WorkCentersComponent";

const QUEUE_LIST_URL = "/production/queue-list";
const ADDRESS_URL = `${QUEUE_LIST_URL}?filter[address]=`;
const MANAGER_URL = `${QUEUE_LIST_URL}?filter[name]=`;
const WORK_CENTER_URL = `${QUEUE_LIST_URL}?filter[work]=`;

const QueueListIndex = () => {
  const navigate = useNavigate();
  const [expandAll, setExpandAll] = useState(true);
  const { data, loading } = useFetch({
    url: `${
      import.meta.env.VITE_VTS_API
    }/v1/production/queue_list/work_center_index`,
  });
  const isSupplierView = data?.supplier_view;

  const handleAddressClick = (value) => navigate(`${ADDRESS_URL}${value}`);

  const handleManagerClick = (value) => navigate(`${MANAGER_URL}${value}`);

  const handleWorkCenterClick = (value) =>
    navigate(`${WORK_CENTER_URL}${value}`);

  const handleRedirectToQueueList = () => navigate(QUEUE_LIST_URL);

  const handleToggleExpandAll = () => setExpandAll(!expandAll);

  return (
    <div>
      <AppBarButtonWrapper showSpinner={loading}>
        <IconButton onClick={handleRedirectToQueueList}>
          <FilterIcon />
        </IconButton>
      </AppBarButtonWrapper>

      {data && (
        <Fade in>
          <div>
            <WorkCenterHeader
              expandAll={expandAll}
              onWorkCenterClick={handleWorkCenterClick}
              onToggleExpandAll={handleToggleExpandAll}
              loading={loading}
              workCenters={data?.work_centers ?? []}
            />
            <QueueListIndexComponent
              ListProps={{ dense: true }}
              MasonryProps={
                isSupplierView ? { columns: { xs: 1, sm: 2 } } : undefined
              }
              data={data?.menu_list}
              expandAll={expandAll}
              onAdressClick={handleAddressClick}
              onManagerClick={handleManagerClick}
              onWorkCenterClick={handleWorkCenterClick}
              managerHref={MANAGER_URL}
              workCenterHref={WORK_CENTER_URL}
              addressHref={ADDRESS_URL}
            />
          </div>
        </Fade>
      )}
    </div>
  );
};

export default QueueListIndex;
